import { useContext } from 'react'
import {
  QueryParamsContext,
  IQueryParamsContext,
} from '../providers/QueryParamsProvider'

export default function useQueryParams(): IQueryParamsContext {
  return useContext(QueryParamsContext)
}
